import React from 'react';
import RadioPlayer from './RadioPlayer';

const App: React.FC = () => {
    return (
        <div>
            <h1>Radio P3 på Proxima Century</h1>
            <p>Hva spiller NRK P3 for romvesnene på Proxima Century om de lytter in nå?</p>
            <RadioPlayer />
        </div>
    );
};

export default App;